module.exports = new __parcel__URL__("shop_machines_sunday_skirmish_trophy2.4205cc7c.png").toString();